import React from 'react';
import '../../../assets/pages/css/login-4.css';
import { ToastContainer, toast } from 'react-toastify'

import Presenter from '../../../../user/model/presenter.js'
import RequestProperties from '../../../../user/model/helper/request.props.js'
import windowStop from '../../../../utils/windowStop';

export default class ResetScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      password : '',
      valid    : false,
      token    : props.match.params.token,
      disabled : true,
    }

    this.onEnter        = this.onEnter.bind(this)
    this.changePassword = this.changePassword.bind(this)

    this.checkToken        = this.checkToken.bind(this)
    this.checkTokenSuccess = this.checkTokenSuccess.bind(this)
    this.checkTokenFailed  = this.checkTokenFailed.bind(this)
    
    this.onReset           = this.onReset.bind(this)
    this.onResetSuccess    = this.onResetSuccess.bind(this)
    this.onResetFailed     = this.onResetFailed.bind(this)
  }

  changePassword(e) {
    let value = e.target.value
    let disabled = true, new_state

    if(value.trim() !== "") {
      disabled = false
    }

    new_state = {
      disabled : disabled,
      password : value,
    }

    this.setState(new_state)
  }

  onEnter(e) {
    if(e.key === 'Enter') {
      this.onReset()
    }
  }

  // check token
  checkToken() {
    const {token} = this.state

    Presenter.CheckTokenReset(
      RequestProperties.CheckTokenReset(token, this.checkTokenSuccess, this.checkTokenFailed)
    )
  }

  checkTokenSuccess(params, response) {
    this.setState({
      valid : true
    })
  }

  checkTokenFailed(response) {
    this.setState({
      valid : false
    })
  }

  // Reset
  onReset() {
    const {password, token} = this.state
    
    Presenter.Reset(
      RequestProperties.Reset(password, token, this.onResetSuccess, this.onResetFailed)
    )

    this.setState({
      process: true,
      disabled: true,
    })
  }

  onResetSuccess(params, response) {  
    this.setState({
      process : false,
      password: "",
      disabled:true,
    })

    alert("Reset password success, please login with new password")
    this.props.history.push('/login')
  }

  onResetFailed(response) {
    this.setState({
      process  : false,
      password : "",
      disabled : true,
    })

    toast.error("Reset password failed, try again.")
  }

  componentDidMount() {
    this.checkToken()
  }
  componentWillUnmount() {
    windowStop()
  }

  renderButton() {
    const {process} = this.state

    if(process) {
      return <button type="button" className="btn btn-primary px-4" disabled><i className='fa fa-spinner fa-pulse fa-fw'></i></button>
    }else {
      return <button type="submit" className="btn btn-primary px-4" onClick={this.onReset}  disabled={this.state.disabled}>Save</button>
    }
  }

  renderField() {
    const {valid} = this.state

    if(valid) {
      return (
        <div className="card-block text-center">
         <h3>Reset password</h3>
          <p className="text-muted">Enter your new password</p>
          <div className="col-md-12">
            <div className="input-group mb-3">
              <input 
                className="form-control col-md-6 offset-md-3" 
                type="password" 
                value={this.state.password}
                placeholder="new password"
                onChange={this.changePassword}
                onKeyPress={this.onEnter}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              {this.renderButton()}
            </div>
          </div>
        </div>
      )
    } else {
      return(
        <div className="card-block text-center">
          <h3>Reset password</h3>
          <p className="text-muted apple-red">Sorry, your token invalid</p>
        </div>
      )
    }

  }

  render() {
    return (
      <div className="app flex-row align-items-center">
        <ToastContainer
           position        ="top-center"
           type            ="default"
           autoClose       ={5000}
           hideProgressBar ={false}
           newestOnTop     ={false}
           closeOnClick
           pauseOnHover
         />
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="card-group mb-0">
                <div className="card p-4">
                  {this.renderField()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/user/reset.js